import React from "react";
import theme from "../../../themes";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Hidden from "@material-ui/core/Hidden";
import RegisterAgentWidget from "../components/RegisterAgentWidget";

const useStyles = makeStyles(() => ({
  rootContainer: {
    [theme.breakpoints.up("md")]: {
      flexGrow: 1,
      display: "flex",
      backgroundColor: theme.palette.background.default,
      minHeight: "calc(100vh - 296px)",
    },
  },
  title: {
    fontSize: 43,
    marginBottom: 45,
    lineHeight: "54px",
    fontWeight: "bold",
    color: theme.palette.getContrastText(theme.palette.primary.dark),
  },
  caption: {
    fontSize: 16,
    marginBottom: 40,
    lineHeight: "26px",
    fontWeight: "bold",
    color: theme.palette.getContrastText(theme.palette.primary.dark),
  },
  paper: {
    minHeight: 730,
    paddingTop: 35,
    paddingBottom: 35,

    [theme.breakpoints.down("sm")]: {
      padding: "35px 20px",
    },
  },
  boxTitle: {
    fontSize: 24,
    fontWeight: "bold",
  },
  boxCaption: {
    marginBottom: 20,
  },
}));

export default function RegisterAgentPage() {
  const classes = useStyles();

  return (
    <>
      <Container>
        <Hidden smDown>
          <Typography component={"h1"} className={classes.title}>
            Education is a passport to step the world and a key to unlock doors.
          </Typography>
        </Hidden>
      </Container>
      <div className={classes.rootContainer}>
        <Container>
          <Paper elevation={0} className={classes.paper}>
            <Typography className={classes.boxTitle}>
              Sign Up As An Agent
            </Typography>
            <Typography className={classes.boxCaption}>
              Hello there, sign up to continue!
            </Typography>
            <RegisterAgentWidget />
          </Paper>
        </Container>
      </div>
    </>
  );
}
